import React from "react";
import { useChangeBackground } from "../hooks/useChangeBackground";
import useVerifyMenu from "../hooks/useVerifyMenu";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import AdminMui from "../components/Masters/AdminMui";
import { useChangeTitleAppBar } from "../hooks/useChangeTitleAppBar";
import {
  ListSuspensionDelantera,
  CreateSuspensionD,
  UpdateSuspensionD,
} from "../utils/SuspensionDelantera";
import EditSuspensionD from "../components/Organisms/SuspensionDelantera/EditSuspensionD/index";
import Swal from "sweetalert2";
import SuspensionDTable from "../components/Organisms/SuspensionDelantera/SuspensionDTable/index";

const SuspensionDelantera = () => {
  const back = useVerifyMenu();
  const history = useHistory();
  const [suspension_d, setSuspension_D] = React.useState([]); // Cargar los datos
  const [againFetch, setAgainFetch] = React.useState(false);
  const [showModal, setShowMondal] = React.useState({
    show: false,
    data: {},
  });

  useChangeBackground("#f5f5f8");
  useChangeTitleAppBar("Configuración de suspensión delantera");

  React.useEffect(() => {
    ListSuspensionDelantera()
      .then((res) => setSuspension_D(res.data))
      .catch((err) =>
        Swal.fire({
          title: "Error!",
          text: err.message || "",
          icon: "error",
          confirmButtonText: "Ok",
        })
      );
  }, [againFetch]);

  const ApiDeleteSuspensionD = (suspensionD) => {
    return UpdateSuspensionD(suspensionD);
  };

  const handleClick = (suspension_name) => {
    if (!suspension_name.id) {
      CreateSuspensionD(suspension_name)
        .then((res) => {
          setShowMondal({
            show: false,
            data: {},
          });
          Swal.fire({
            title: "Proceso Ejecutado exitosamente!",
            text: res.message || "",
            icon: "success",
            confirmButtonText: "Ok",
          }).then(() => setAgainFetch(!againFetch));
        })
        .catch((err) => {
          setShowMondal({
            show: false,
            data: {},
          });
          Swal.fire({
            title: "Error!",
            text: err || "",
            icon: "error",
            confirmButtonText: "Ok",
          });
        });
    } else {
      UpdateSuspensionD(suspension_name)
        .then((res) => {
          setShowMondal({
            show: false,
            data: {},
          });
          Swal.fire({
            title: "Proceso Ejecutado exitosamente!",
            text: res.message || "",
            icon: "success",
            confirmButtonText: "Ok",
          }).then(() => setAgainFetch(!againFetch));
        })
        .catch((err) => {
          setShowMondal({
            show: false,
            data: {},
          });
          Swal.fire({
            title: "Error!",
            text: err.message || "",
            icon: "error",
            confirmButtonText: "Ok",
          });
        });
    }
  };

  return !back ? (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Configuración de suspension delantera - Supre</title>
        <meta name="description" content="suspension delantera admin supre" />
      </Helmet>

      <AdminMui>
        <SuspensionDTable
          suspension_d={suspension_d}
          ApiDeleteSuspensionD={ApiDeleteSuspensionD}
          setAgainFetch={setAgainFetch}
          setShowMondal={setShowMondal}
          againFetch={againFetch}
        />
        {showModal.show && (
          <EditSuspensionD
            showModal={showModal}
            setShowMondal={setShowMondal}
            handleClick={handleClick}
          />
        )}
      </AdminMui>
    </>
  ) : (
    <>{history.push("/admin/login")}</>
  );
};

export default SuspensionDelantera;
